<template>
  <main class="container solution-water">
    <section ref="sectionRef" class="wellcome-section">
      <button class="btn outline">Water Purifier</button>
      <h1>
        Water you can trust to drink,
        <br />
        Water Quality Assurance Solution
      </h1>
      <p>
        Dedicated to research on sterilization and microplastic removal, <br class="pc_show" />
        CESCO ensures the provision of reliable, clean water and maintains the hygiene of spaces where its products are used.
      </p>

      <router-link to="/contact/mail/send?local=eng">
        <p ref="buttonRef" id="applyButton" :class="[buttonClass, buttonHiddenClass]">Send Email</p>
      </router-link>
    </section>
    <img
      :src="require(`@/assets/images/solution/water/main${mobileCheck ? '_mo' : ''}.png`)"
      class="main-img"
      alt="CESCO [Solution] Water Purifier"
    />

    <section class="section solution-water-1">
      <div class="contents-center">
        <h3 class="title-section">Why CESCO Water?</h3>
        <div class="cards">
          <div class="card-type-f">
            <div>
              <h4>Mission and Sincerity for Customers</h4>
              <p>
                CESCO actively monitors the environmental hygiene associated with daily activities—breathing, eating, and drinking—to foster a more
                trustworthy and secure environment. The CESCO Water System not only purifies water but also removes heavy metals, bacteria, and
                viruses.
              </p>
            </div>
            <img src="@/assets/images/solution/water/card_f_01.png" alt="CESCO [Solution] Water Purifier" />
          </div>
          <div class="card-type-f">
            <div>
              <h4>CESCO Science is committed to supplying safer water</h4>
              <p>
                Driven by a mission to provide safe water for both drinking and cooking, we develop water quality assurance solutions to safeguard
                public health.
              </p>
            </div>
            <img src="@/assets/images/solution/water/card_f_02.png" alt="CESCO [Solution] Water Purifier" />
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-water-2">
      <div class="contents-center">
        <h3 class="title-section center">CESCO SterilizationON Water Purifier Lineup</h3>
        <p class="description-section center">
          CESCO is committed to providing clean water through its sterilization and
          <br />
          microplastic removal systems, leveraging its extensive hygiene expertise.
        </p>

        <div class="product-list">
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                SterilizationON
                <br />
                Water Purifier with 5-Level Safety
              </h3>
              <p class="note">(Hot and Cold)</p>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_01.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              As the first in Korea, this system provides 5-level safety care from the spout to the flow path and includes a microplastic filtration
              filter, delivering consistently clean water with a direct water system for both hot and cold settings.
            </div>
          </div>
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                SterilizationON
                <br />
                Ice
                <br class="pc_show" />
                Water Purifier
              </h3>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_02.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              This purifier provides cleaner water and ice with 5-level safety care and a microplastic filtration filter, all through a direct water
              system for both hot and cold settings.
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-water-3">
      <div class="contents-center">
        <h3 class="title-section center">CESCO Smart-Fit <br class="mo_show" />Lineup</h3>

        <div class="product-list">
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit
                <br />
                Direct
                <br />
                Water Purifier
              </h3>
              <p class="note">(Hot and Cold)</p>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_03.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              This purifier offers eight color options to suit personal tastes and is designed to allow exterior replacement during use with the
              DefenseAir hot and cold direct system.
            </div>
          </div>
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit
                <br />
                Mini
                <br />
                Water Purifier
              </h3>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_04.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              This model operates without a reservoir, offering clean water directly and economically with zero electricity costs, and features an
              ultra-slim design at just 11.5cm wide.
            </div>
          </div>
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit
                <br />
                Stand
                <br />
                Water Purifier
              </h3>
              <p class="note">(Hot and Cold)</p>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_05.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              Available in two colors, this purifier offers a substantial 13.9L output and a spacious water intake area with a height of 27cm.
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section solution-water-4">
      <div class="contents-center">
        <h3 class="title-section center">CESCO Smart-Fit THE Slim Lineup</h3>
        <p class="description-section center">
          With a slim size and simple design, this lineup enhances space utilization.
          <br />
          Prices are kept slim, and combining memberships further enhances the savings.
        </p>

        <div class="product-list">
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit Stand <br class="mo_show" />Water Purifier
                <br />
                THE Slim
              </h3>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_06.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              Ultra-slim design, with a width of 23 cm, fits into narrow spaces and provides ample output for multi-user facilities
            </div>
          </div>
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit
                <br />
                Water Purifier
                <br />
                THE Slim
              </h3>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_07.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">23 cm ultra-slim size; desktop type design considers space efficiency and decor</div>
          </div>
          <div class="product-card">
            <div class="header">
              <h3 class="product-name">
                Smart-Fit
                <br />
                Water Purifier
                <br />
                THE Slim Double
              </h3>
            </div>
            <img class="product-image" src="@/assets/images/solution/water/product_08.png" alt="CESCO [Solution] Water Purifier" />
            <div class="content">
              Designed for locations with high water usage, it doubles the output and features a 27 cm slim design that fits naturally into any space
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="navi-swiper solution-water-5">
      <div>
        <h3>
          CESCO Water Solution, Perfected by
          <br />
          CESCO Science
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide class="water-slide">
          <h6 class="title">
            Exclusive Space Care Service PlusAlphaCare from
            <br />
            CESCO
          </h6>
          <div class="content">
            <div class="content-slide">
              PlusAlphaCare, a distinctive service that only CESCO offers, enables management of both the product and the surrounding space.
            </div>
            <img class="background" src="@/assets/images/solution/water/water_swiper_01.png" alt="CESCO [Solution] Water Purifier" />
          </div>
        </swiper-slide>
        <swiper-slide class="water-card-slide">
          <h6 class="title">
            World's best food safety
            <br />
            infrastructure
          </h6>
          <div class="slide-content">
            <div>
              <p>
                The care regimen includes immediate spout sterilization after dispensing, hourly spout sterilizations, draining the water path every
                three hours, sterilizing the water path every three days, and replacing the spout annually.
              </p>

              <img
                :src="require(`@/assets/images/solution/water/water_swiper_02${mobileCheck ? '_mo' : ''}.svg`)"
                alt="CESCO [Solution] Water Purifier"
              />
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="water-card-slide">
          <h6 class="title">5-stage composite nano filter system that filters everything from microplastics to organic materials</h6>
          <div class="slide-content">
            <div class="center-content">
              <p>
                Experience consistently clean water with CESCO Water's unique 5-stage composite nano filter system.This system removes heavy metals,
                bacteria, and microplastics while preserving minerals and has beenverified by dual certifications, including one for non-detection of
                microplastics.
              </p>

              <div>
                <img
                  :src="require(`@/assets/images/solution/water/water_swiper_03${mobileCheck ? '_mo' : ''}.svg`)"
                  alt="CESCO [Solution] Water Purifier"
                />
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="water-slide">
          <h6 class="title">5-stage composite nano filter system that filters everything from microplastics to organic materials</h6>
          <div class="content">
            <div class="content-slide">
              <p class="desc">
                The CESCO SterilizationON Water Purifier dispenses cold, purified, and hot water directly, providing clean water immediately without
                any stagnation.
              </p>
            </div>

            <img class="background" src="@/assets/images/solution/water/water_swiper_04.png" alt="CESCO [Solution] Water Purifier" />
          </div>
        </swiper-slide>
        <swiper-slide class="water-card-slide">
          <h6 class="title">Produces solid and transparent ice from clean, sterilized water with 5-Level Safety Care</h6>
          <div class="slide-content">
            <div>
              <p>
                The ice care routine includes spout sterilization every two hours, ice dispensing every two hours, ice storage care every two hours,
                water path emptying every 24 hours, and spout replacement annually, ensuring everything from clean water to safe ice.
              </p>
              <img
                :src="require(`@/assets/images/solution/water/water_swiper_05${mobileCheck ? '_mo' : ''}.svg`)"
                alt="CESCO [Solution] Water Purifier"
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </section>

    <section class="section tab-area solution-water-6">
      <div class="contents-center">
        <div class="tab-info">
          <h3 class="title-section">CESCO Science Care</h3>
        </div>

        <div class="tabs">
          <button
            v-for="item in tabList"
            :key="`tab-${item.id}`"
            :id="`tab-${item.id}`"
            :class="['tab-button', tab === item.id && 'active']"
            @click="handleTabClick(item.id)"
          >
            {{ item.name }}
          </button>
        </div>

        <button class="btn-list">Press the button to check.</button>
      </div>

      <div v-if="!mobileCheck" class="tab-contents">
        <div v-if="tab === 0" class="tab-content">
          <div class="card-area">
            <div class="slide-card">
              <h3>
                Water quality management professionals, trained at the CESCO Touch Center and
                <br />
                CESCO Members City with sophisticated training facilities,
                <br />
                meticulously manage these services.
              </h3>
              <div class="cards">
                <div>
                  <img src="@/assets/images/solution/water/tab01_01.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Care Service</h4>
                  <p>Dedicated filter replacement, spout replacement, and consumables management by CESCO ensure meticulous care of your product.</p>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab01_02.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Product Consulting</h4>
                  <p>
                    We collaborate with you to develop strategies for enhancing your lifestyle, offering in-depth consultations on product usage and
                    various services.
                  </p>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab01_03.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Customer Management</h4>
                  <p>
                    Beyond the products you currently use, we deliver specialized information about products and services that align with your
                    lifestyle.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tab === 1" class="tab-content">
          <swiper :slides-per-view="'auto'" :centered-slides="true">
            <swiper-slide class="water-tab-slide-1">
              <h3>
                Systematic product care designed with
                <br />
                CESCO’s sterilization science expertise
              </h3>
              <div class="science-expertise-cards">
                <div>
                  <img src="@/assets/images/solution/water/tab02_01.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>
                    Composite Nano Filter Replacement
                    <br />
                    (4 months/12 months)
                  </h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_02.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Spout Inspection/Sterilization</h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_03.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>
                    Spout Replacement
                    <br />
                    (12 months)
                  </h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_04.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Prefilter Inspection/Sterilization</h4>
                </div>
              </div>
              <div class="science-expertise-cards">
                <div>
                  <img src="@/assets/images/solution/water/tab02_05.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Tray Cleaning</h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_06.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Exterior Cleaning</h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_07.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Exterior Sterilization</h4>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_08.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Internal Waterway Sterilization</h4>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="water-tab-slide-1">
              <h3>
                Scientific tools designed to prevent
                <br />
                cross-contamination
              </h3>
              <div class="cross-contamination">
                <div>
                  <img src="@/assets/images/solution/water/tab02_09.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>Electrolyzed Water Sterilization Service</h4>
                  <p>Sterilizes the pathways through which water travels to provide clean water and prevent recontamination</p>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_10.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>
                    Exclusive
                    <br />
                    Service Pack
                  </h4>
                  <p>Offers focused care for individual customers and blocks cross-contamination</p>
                </div>
                <div>
                  <img src="@/assets/images/solution/water/tab02_11.png" alt="CESCO [Solution] Water Purifier" />
                  <h4>
                    UV-C Sterilization
                    <br />
                    Service Bag
                  </h4>
                  <p>Ensures service tools are stored in a hygienic manner</p>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div v-if="tab === 2" class="tab-content" id="tab3">
          <swiper :slides-per-view="'auto'" :centered-slides="true">
            <swiper-slide class="water-tab-slide-2">
              <div>
                <h3>
                  PlusAlphaCare, exclusively from CESCO,
                  <br />
                  offers a comprehensive environmental hygiene solution that not only manages
                  <br />
                  the water purifier but also the surrounding kitchen area.
                </h3>
              </div>

              <img class="background" src="@/assets/images/solution/water/tab03_01.svg" alt="CESCO [Solution] Water Purifier" />
            </swiper-slide>
            <swiper-slide class="water-tab-slide-3">
              <div>
                <h3>
                  Manages hygiene around water purifiers, an area susceptible to becoming
                  <br />
                  a breeding ground for pests due to humidity and high temperatures
                </h3>
                <div class="card-grid">
                  <div class="image">
                    <img src="@/assets/images/solution/water/tab03_02.png" alt="CESCO [Solution] Water Purifier" />
                  </div>
                  <div class="card-row">
                    <h4>1 / 2 Pest Monitoring & One-Time Home Pest Control Service</h4>
                    <p>
                      Installs pest monitoring traps with CESCO technology, regularly checks for pest ingress, and provides a one-time free pest
                      control service if pests are detected (service available once within 36 months).
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="water-tab-slide-3">
              <div>
                <h3>
                  Manages drain odors and bug eggs caused by
                  <br />
                  food residues and water stains
                </h3>
                <div class="card-grid">
                  <div class="image">
                    <img src="@/assets/images/solution/water/tab03_03.png" alt="CESCO [Solution] Water Purifier" />
                  </div>
                  <div class="card-row">
                    <h4>3 Drain Hygiene Management Service</h4>
                    <p>Regularly uses a drain cleaner that cleans deeply with rich foam, removing debris, substances causing odors, and bug eggs.</p>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="water-tab-slide-3">
              <div>
                <h3>
                  Provides surface sterilization management for kitchen spaces
                  <br />
                  where frequent cooking facilitates the proliferation of bacteria and viruses!
                </h3>
                <div class="card-grid">
                  <div class="image">
                    <img src="@/assets/images/solution/water/tab03_04.png" alt="CESCO [Solution] Water Purifier" />
                  </div>
                  <div class="card-row">
                    <h4>4 Surface Sterilization Service</h4>
                    <p>
                      We thoroughly sterilize the surfaces of water purifiers and the surrounding kitchen areas using a 100% food additive-based grain
                      fermentation sterilization disinfectant.
                    </p>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </section>

    <section ref="checkSectionRef" class="sub-footer">
      <h2>We are fully committed to research on <br class="pc_show" />sterilization and microplastic removal.</h2>
      <p>
        A single water purifier provides a unique experience, introducing you to the No.1 <br class="pc_show" />comprehensive environmental hygiene
        solution.
      </p>

      <router-link to="/contact/mail/send?local=eng" class="btn"> Send Email </router-link>
    </section>
  </main>

  <ModalView v-if="mobileCheck" :modal-state="modalState" @close-modal="closeModal">
    <WaterModalContent :tab="tab" :text="tabList[tab].name" />
  </ModalView>
</template>

<script setup>
import { inject } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useMeta } from 'vue-meta'
import { useScroll, useSlide, useModal, useTab } from '@/hooks'
import ModalView from '@/components/common/ModalView.vue'
import WaterModalContent from '@/components/modal/WaterModalContent.vue'

const { sectionRef, checkSectionRef, buttonRef, buttonClass, buttonHiddenClass } = useScroll()
const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()
const { tab, handleTabClick } = useTab(openModal)

const mobileCheck = inject('mobileCheck')

const tabList = [
  { id: 0, name: 'Systematic Management' },
  { id: 1, name: 'Water Purifier Hygiene Management Service' },
  { id: 2, name: 'PlusAlphaCare' }
]

useMeta({
  title: 'CESCO - Water Purifier',
  meta: [
    {
      vmid: 'description',
      name: 'description',
      content: 'Water you can trust to drink, Water Quality Assurance Solution'
    }
  ]
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/water.scss';
</style>
